import styled from 'styled-components';
import { useCameraViewContext } from '../../context';
import React from 'react';

const Wrapper = styled.div`
  width: 40px;
  height: 40px;
  outline: 3px solid #fff;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 16px;
  bottom: ${props => `${props.lift + 16}px`};

  & > span {
    color: #fff;
    font-size: 17px;
    font-weight: 700;
    line-height: 22px;
  }

  @media (orientation: landscape) {
    position: static;
  }
`;

type Props = {
  lift?: number;
};

export const Counter: React.FC<Props> = ({ lift = 0 }) => {
  const { imageIndex, level1SectionId } = useCameraViewContext();

  return (
    <Wrapper lift={lift}>
      <span>{level1SectionId === 'drive_cycles' ? 1 : imageIndex + 1}</span>
    </Wrapper>
  );
};
